<template>
  <div class="product d-flex flex-column my-4 justify-content-between">
    <h3>{{ product.company_name }}</h3>
    <div class="d-flex border-bottom pt-2 pb-4 align-items-center">
      <!-- <input
        class="me-4"
        type="checkbox"
        :id="'product-' + product.id"
        :value="product.id"
        v-model="checked"
        @change="emitSelection"
      /> -->
      <div class="product__image">
        <img :src="product.images?.at(0)?.image || require('@/assets/images/logo_info.svg')" alt="" />
      </div>
      <div class="product__content mx-4">
        <h3>{{ product.name }}</h3>
        <p class="mb-0">{{ truncateContent(product.description) }}</p>
      </div>

      <div class="product__counts d-flex align-items-center">
        <Counter
          :small="true"
          :count="countToAdd"
          :count-inc="handleIncrement"
          :count-dec="handleDecrement"
          :add-to-cart="updateQuantity"
        />
        <h2 class="ms-4 mb-0">
          {{ formatPrice(currentPrice * countToAdd) }}
        </h2>
      </div>

      <button class="button-transparent ms-auto" @click="removeItem">
        <img src="@/assets/images/icons/trash.svg" />
      </button>
    </div>
  </div>
</template>

<script>
  import marketplaceService from '@/services/marketplace';
  import Counter from '@/components/Profile/Counter.vue';
  import { ref, defineComponent, watch, computed } from 'vue';
  import { useStore } from 'vuex';
  import { useDebounceFn } from '@vueuse/core';
  import { Modal } from 'bootstrap';

  export default defineComponent({
    name: 'ProfileProductCard',
    components: {
      Counter,
    },
    props: {
      product: Object,
      id: Number,
      reloadCart: Function,
      quantity: Number,
      selectedProducts: Array,
    },
    setup(props, { emit }) {
      const store = useStore();
      const countToAdd = ref(props.quantity);
      const checked = ref(props.selectedProducts.includes(props.product.id));
      const productAdded = ref(false);

      const isLoggedIn = computed(() => store.state.auth.status.loggedIn);

      const currentPrice = computed(() => {
        return props.product.sale_price && Number(props.product.sale_price) > 0
          ? props.product.sale_price
          : props.product.price;
      });

      const openModal = () => {
        const modalEl = document.getElementById('authModal');
        if (modalEl) {
          const loginModal = new Modal(modalEl);
          loginModal.show();
        }
      };

      const emitSelection = () => {
        const updatedSelection = checked.value
          ? [...props.selectedProducts, props.product.id]
          : props.selectedProducts.filter((id) => id !== props.product.id);
        emit('update:selectedProducts', updatedSelection);
      };

      const updateQuantity = useDebounceFn(async (newVal) => {
        const delta = newVal - props.quantity;
        if (delta !== 0) {
          try {
            await marketplaceService.addToBasket(props.product.id, delta);
            await store.dispatch('user/getCartItems');
            props.reloadCart();
          } catch (e) {
            countToAdd.value = props.quantity;
          }
        }
      }, 500);

      const handleIncrement = () => {
        countToAdd.value++;
        updateQuantity(countToAdd.value);
      };

      const handleDecrement = () => {
        if (countToAdd.value > 1) {
          countToAdd.value--;
          updateQuantity(countToAdd.value);
        }
      };

      const removeItem = async () => {
        await marketplaceService.delete(props.id);
        props.reloadCart();
        store.dispatch('user/getCartItems');
      };

      const truncateContent = (content) => {
        if (!content) return '';
        return content.length > 64 ? content.slice(0, 64) + '...' : content;
      };

      const formatPrice = (price) => {
        return new Intl.NumberFormat('ru-RU', {
          style: 'currency',
          currency: 'RUB',
          minimumFractionDigits: 0,
        }).format(price);
      };

      watch(
        () => props.selectedProducts,
        (newSelection) => {
          checked.value = newSelection.includes(props.product.id);
        }
      );

      watch(
        () => props.quantity,
        (newVal) => {
          countToAdd.value = newVal;
        }
      );

      return {
        countToAdd,
        checked,
        isLoggedIn,
        productAdded,
        currentPrice,
        emitSelection,
        handleIncrement,
        handleDecrement,
        updateQuantity,
        removeItem,
        truncateContent,
        formatPrice,
        openModal,
      };
    },
  });
</script>

<style scoped lang="scss">
  .product {
    &__content {
      width: 15rem;
    }

    &__counts {
      // width: 10rem;
    }
  }

  input[type='checkbox'] {
    margin: 10px;
    transform: scale(1.5);
  }

  .transition-button {
    height: 42px;

    font-weight: 700;
    font-size: 15px;

    border-radius: 20px;

    transition: all 0.3s ease;
  }

  .btn-light-custom {
    color: #0066ce;

    background-color: #d5eaff;
    border: none;

    &:hover {
      background-color: #c0deff;
    }
  }

  .btn-added {
    color: white !important;

    background-color: #58b251 !important;
    border: none;
    transform: scale(1.02);
  }

  .icon-white {
    filter: brightness(0) invert(1);
  }
</style>
